import { Component, Prop } from "vue-property-decorator";
import Vue from "vue";

@Component({
    name: 'Dropzone',
    components: {},
    directives: {}
})
export default class Dropzone extends Vue {
    @Prop({ default: '10em' })
    private readonly minHeight!: string;
    @Prop({ type: Function, default: (f) => true })
    private readonly acceptsFileFn!: (File) => boolean;
    @Prop({ type: Function, default: (f) => true })
    private readonly handleFileFn!: (File) => boolean;

    //runtime
    private dragCounter: number = 0;//needs to be a counter, as the @dragenter and @dragleave events are also fired for every child element, 0 means not dragged over, >0 means dragged over

    //
    private dragenter(event: DragEvent): void {
        this.dragCounter++;
    }

    private dragleave(event: DragEvent): void {
        this.dragCounter--;
    }

    private dragover(event: DragEvent): void {
        if (!event.dataTransfer 
            || event.dataTransfer.items.length !== 1
            || event.dataTransfer.items[0].kind !== 'file') {
            return;
        }
        if (this.acceptsFileFn(event.dataTransfer.items[0].getAsFile())) {
            event.preventDefault(); //prevent browser to do something with the dragged file
            return;
        }
    }

    private drop(event: DragEvent): void {
        this.dragCounter = 0;
        if (!event.dataTransfer
            || event.dataTransfer.items.length !== 1
            || event.dataTransfer.items[0].kind !== 'file') {
            return;
        }
        if (this.handleFileFn(event.dataTransfer?.items[0].getAsFile())) {
            event.preventDefault(); //prevent browser to do something with the dragged file
            return;
        }

        //TODO impl upload functionality later
    }

    //computed
    private get style(): object {
        let ret: any = {
            'min-height': this.minHeight,
            border: 'none',
            'border-radius': '5px',
            // transition: 'border-color 250ms',
        };
        if (this.dragCounter > 0) {
            ret = Object.assign(ret, {
                border: '5px dashed var(--gray)',
            });
        }
        return ret;
    }
}